import parse, { Element, HTMLReactParserOptions } from 'html-react-parser'
import React, { FC, useCallback, useEffect, useMemo } from 'react'

import { ArticleReadOnlyContainer } from '../../layout_components/common.components'
import { ArticleInfo } from '../definitions'
import { SubArticle } from '../SubArticle/subarticle.components'
import { CustomBlock } from './article.components'

interface Props {
  changeView: (permalink: string, type: string) => void
  parentsArticle: string[]
  isInternal?: boolean
  article: ArticleInfo
  searchKey: string
  setReferences: (sections: { node: HTMLDivElement; top: number }[]) => void
  viewportWidth: number
  subArticle: boolean
  isExternal: boolean
}
const ArticleReadOnlyMode: FC<Props> = (props: Props) => {
  const sections: { node: HTMLDivElement; top: number }[] = []

  const hashSection = () => {
    let hash = window.location.hash
    if (hash) {
      hash = hash.substring(1)
      if (!hash.startsWith('section_')) {
        hash = 'section_' + hash;
      }
      const targetElement = document.getElementById(hash)
      targetElement?.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (
        domNode instanceof Element &&
        domNode.attribs.type === 'article' &&
        domNode.name == 'reactelement'
      ) {
        return (
          <SubArticle
            key={domNode.attribs.key}
            text={domNode.attribs.title}
            permalink={domNode.attribs.permalink}
            className={'subArticle'}
            changeView={props.changeView}
            parentsArticle={props.parentsArticle}
            isInternal={props.isInternal}
          />
        )
      } else if (
        domNode instanceof Element &&
        domNode.attribs.type !== 'article' &&
        domNode.name == 'reactelement'
      ) {
        return (
          <CustomBlock
            key={domNode.attribs.key}
            type={domNode.attribs.type}
            text={domNode.attribs.text}
            color={domNode.attribs.color ? domNode.attribs.color : undefined}
            id={
              domNode.attribs.type === 'section'
                ? domNode.attribs.id
                : undefined
            }
            ref={(ref) => {
              if (ref && domNode.attribs.type === 'section') {
                sections[parseInt(domNode.attribs.section_number)] = {
                  node: ref,
                  top: null,
                }
                props.setReferences(sections)
              }
            }}
          />
        )
      } else {
        return domNode
      }
    },
  }

  useEffect(()=> {
    hashSection()
  }, [window.location.hash, props.article])

  const renderContent = useCallback(() => {
    if (!props.article) return <></>
    return parse(props.article.parsed_content, options)
  }, [props.article])

  const renderArticleContent = useMemo(() => renderContent(), [props.article])

  return (
    <ArticleReadOnlyContainer className={'fr-view'} id={'printSection-' + props.searchKey}>
      {renderArticleContent}
    </ArticleReadOnlyContainer>
  )
}

export default ArticleReadOnlyMode
